import { Injectable } from '@angular/core';
import { isNil } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class UrlParseUtilitiesService {
  public tryParseJson<T>(jsonString: string | null | undefined, fallbackValue: any = false): T | null | undefined {
    if (isNil(jsonString)) {
      return jsonString as null | undefined;
    }

    try {
      return JSON.parse(jsonString);
    } catch {
      return fallbackValue;
    }
  }
}
